import { array, boolean, object } from "superstruct";

import WishlistsSocialShareChannelsSchema from "./WishlistsSocialShareChannelsSchema";

export const WishlistsStorefrontValuesSettingsSchema = object({
    isDisabledForGuests: boolean(),
    isSaveWishlistEnabled: boolean(),
    isWishlistDrawerEnabled: boolean(),
    isWishlistSocialShareEnabled: boolean(),
    wishlistSocialShareChannels: array(WishlistsSocialShareChannelsSchema),
    isShareSeparateWishlistsEnabled: boolean(),
    isCreateDraftOrderFromListEnabled: boolean(),
    isListsApprovalByCompanyMembersEnabled: boolean(),
    isDuplicateWishlistEnabled: boolean(),
    isEditListsByCompanyMembersEnabled: boolean(),
    isEditProductQuantityEnabled: boolean(),
    isWishlistApprovalRequestNotificationEnabled: boolean(),
    isWishlistApprovalCompletedNotificationEnabled: boolean(),
});
